export interface ProfileValue {
  value: string;
}

interface ProfileProps {
  [key: string]: ProfileValue
}

export const profile: ProfileProps = {
  PEAO: {
    value: 'PEAO',
  },
  GERENTE: {
    value: 'GERENTE',
  },
  DONO: {
    value: 'DONO',
  },
}

export const profileOptions = Object.keys(profile).map((key: string) => profile[key])
